import { motion } from "framer-motion";
import { CHAPTERS } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";

export const Manifesto = () => (
  <section id="approach" className="relative py-28 lg:py-40 bg-ink" data-testid="manifesto-section">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <SectionHead index="02" eyebrow="Our Approach" title={<>A managed path into value-add real estate.</>} />
          <Reveal delay={0.2}>
            <p className="mt-8 text-ivory/60 leading-relaxed max-w-md">
              Many professionals have income, credit and capital — but not the hours to search listings, inspect
              properties, chase contractors or compare financing structures. We do that work, in four chapters.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 gold-rule w-40" />
          </Reveal>
        </div>
      </div>

      <ol className="lg:col-span-7 border-t border-gold/15" data-testid="manifesto-chapters">
        {CHAPTERS.map((c, i) => (
          <motion.li
            key={c.num}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="chapter group grid grid-cols-[4rem_1fr] sm:grid-cols-[7rem_1fr] gap-6 py-12 border-b border-gold/15"
            data-testid={`chapter-${c.num}`}
          >
            <span className="chapter-num font-mono text-sm text-ivory/35 pt-2 transition-colors duration-400">{c.num}</span>
            <div>
              <h3 className="font-serif text-3xl sm:text-4xl text-ivory tracking-tight">{c.title}</h3>
              <p className="mt-5 text-ivory/60 leading-relaxed max-w-xl">{c.body}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
